const taxonomyQueryKeys = {
  TAXONOMY_LIST: ['TAXONOMY_LIST'] as const,
  TAXONOMY_SETUP: ['TAXONOMY_SETUP'] as const,
  TAXONOMY_ITEM: ['TAXONOMY_ITEM'] as const,

  TOPIC_PREVIEW_LIST: ['TOPIC_PREVIEW_LIST'] as const,
  TOPIC_FEEDBACK_LIST: ['TOPIC_FEEDBACK_LIST'] as const,
  TOPIC_DETAIL: ['TOPIC_DETAIL'] as const,

  TOPIC_DETAIL_FEEDBACK_COUNT: ['TOPIC_DETAIL_FEEDBACK_COUNT'] as const,
  TOPIC_DETAIL_UNLINKED_FEEDBACK_COUNT: ['TOPIC_DETAIL_UNLINKED_FEEDBACK_COUNT'] as const,

  AI_SUGGESTION_LIST: ['AI_SUGGESTION_LIST'] as const,
};

export default taxonomyQueryKeys;
